import React from "react";
import { Link } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";

function MoreContent() {
  return (
    <div className="bg-[#f8fafc] font-amiriQuran bg-custom-bg">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 md:py-20">

        <div className="mx-auto max-w-4xl lg:mx-0 mb-16 lg:mb-24">
          <div className="relative">
            <h2 className="text-4xl md:text-5xl lg:text-5xl font-bold leading-tight text-[#0F172A]">
              Don't Compare the price{' '}
              <span className="text-[#0e4322]">Compare the Quality.</span>
            </h2>
            <p className="mt-8 text-lg md:text-xl lg:text-2xl leading-relaxed text-[#1F2937]">
              True value lies not in what you save today but in the lasting satisfaction you gain tomorrow. Quality ensures trust, durability, and long-term benefits that far outweigh short-term cost savings.
            </p>
            <div className="absolute -right-20 -top-10 hidden lg:block">
              <img src="/svg/SVG1.svg" alt="" className="w-32 h-32 opacity-80" />
            </div>
          </div>
        </div>

        {/* Cards Section - Sales Focused Design */}
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-3 lg:gap-12 lg:px-8">
          {/* About Us Card - Premium Blue */}
          <Link
            to="/aboutus"
            className="group relative flex flex-col justify-between overflow-hidden rounded-3xl bg-gradient-to-br from-blue-900 to-blue-700 p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl hover:-translate-y-3"
          >
            <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/5"></div>
            <div className="absolute -left-10 -bottom-10 h-32 w-32 rounded-full bg-white/5"></div>
            <div className="relative z-10">
              <div className="mb-6 flex items-center gap-3">
                <h3 className="text-3xl font-bold text-white">About us</h3>
              </div>
              <p className="text-lg font-semibold text-white">
                Welcome to NextEra Research
              </p>
              <p className="mt-4 text-base leading-relaxed text-white/90">
                A SEBI-registered  Research Analyst providing accurate, unbiased research on securities, commodities, and currencies. We analyze financial performance and market trends to help you make informed investment decisions.
                <FaArrowCircleRight /></p>
            </div>
          </Link>

          {/* Our Mission Card - Vibrant Teal */}
          <Link
            to="/aboutus"
            className="group relative flex flex-col justify-between overflow-hidden rounded-3xl bg-gradient-to-br from-teal-600 to-emerald-600 p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl hover:-translate-y-3"
          >
            <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/5"></div>
            <div className="absolute -left-10 -bottom-10 h-32 w-32 rounded-full bg-white/5"></div>
            <div className="relative z-10 items-center">
              <div className="mb-6 flex items-center gap-3">
                <h3 className="text-3xl font-bold text-white">Our Mission</h3>
              </div>
              <p className="mt-4 text-base leading-relaxed text-white/90">
                We aim to provide accurate and timely research, analysis, and recommendations to investors, enabling them to make informed decisions and achieve their financial goals.
              </p>
            </div>
            <div className="mt-8 flex items-center text-white/90 group-hover:text-white transition-colors duration-300">
              <span className="font-medium">Learn how we help you <FaArrowCircleRight /></span>
            </div>
          </Link>

          {/* Our Vision Card - Royal Purple */}
          <Link
            to="/aboutus"
            className="group relative flex flex-col justify-between overflow-hidden rounded-3xl bg-gradient-to-br from-purple-700 to-indigo-700 p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl hover:-translate-y-3"
          >
            <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/5"></div>
            <div className="absolute -left-10 -bottom-10 h-32 w-32 rounded-full bg-white/5"></div>
            <div className="relative z-10">
              <div className="mb-6 flex items-center gap-3">
                <h3 className="text-3xl font-bold text-white">Our Vision</h3>
              </div>
              <p className="mt-4 text-base leading-relaxed text-white/90">
                To empower investors with knowledge and security through unbiased, transparent, and reliable research.
              </p>
            </div>
            <div className="mt-8 flex items-center text-white/90 group-hover:text-white transition-colors duration-300">
              <span className="font-medium">See the future with us <FaArrowCircleRight /></span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MoreContent;
